/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */

const PieChart = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 80 80"><path fill="#fea58e" d="M57.3,10.1C51.8,6.9,47,5.7,40,5.7v15.4c3.4,0,6.7,0.9,9.4,2.5L57.3,10.1z"></path><path fill="#51d3d9" d="M57.3,10.1l-7.8,13.6c5.7,3.3,9.5,9.4,9.5,16.4h15.7C74.6,27,68.3,16.4,57.3,10.1z"></path><path fill="#bda9ea" d="M58.9,40c0,10.4-8.5,18.9-18.9,18.9c-3.3,0-6.5-0.9-9.2-2.4l-7.6,13.7c5.5,3.2,10.4,4,16.8,4C59.1,74.2,74.6,59,74.6,40H58.9z"></path><path fill="#f5c78e" d="M21.1,40c0-10.4,8.5-18.9,18.9-18.9V5.7C28,5.7,16.7,12,10.3,23C0.8,39.5,6.7,60.6,23.2,70.2l7.6-13.6C25,53.3,21.1,47.1,21.1,40z"></path></svg>
	);
};

export default PieChart;
